var map = {
	"./barchart.svg": 1170,
	"./car.svg": 1171,
	"./circlediagram.svg": 1172,
	"./citywithdots.svg": 1173,
	"./cloud.svg": 1174,
	"./cloud2.svg": 1175,
	"./concept.svg": 1176,
	"./config.svg": 1177,
	"./data.svg": 1178,
	"./devices.svg": 1179,
	"./earth.svg": 1180,
	"./girl.svg": 1181,
	"./hosting.svg": 1182,
	"./mobile.svg": 1183,
	"./notifications.svg": 1184,
	"./predictions.svg": 1185,
	"./privacy.svg": 1186,
	"./projects.svg": 1187,
	"./search.svg": 1188,
	"./settings.svg": 1189,
	"./sharing.svg": 1190,
	"./storage.svg": 1191,
	"./users.svg": 1192
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1169;